"use client";

import BrandList from "@/containers/category/BrandList";
import { getAllBrands } from "@/requests/brand";
import { NextPage } from "next";
import { useEffect, useRef, useState } from "react";
import InfiniteScroll from "react-infinite-scroller";

const BrandListPage: NextPage = () => {
  const [brands, setBrands] = useState<BrandItem[]>([]);
  const [page, setPage] = useState<number>(1);
  const [totalPage, setTotalPage] = useState<number>(1);
  const [loading, setLoading] = useState<boolean>(true);

  const [searchText, setSearchText] = useState<string>("");

  const pageLoading = useRef(true);

  useEffect(() => {
    const abortController = new AbortController();

    setLoading(true);
    const timeout = setTimeout(() => {
      getAllBrands({
        currentPage: 1,
        search: searchText,
        perPage: 20,
        sortBy: "serial_no",
        sortOrder: "ASC",
        config: {
          signal: abortController.signal,
        },
      })
        .then((data) => {
          setBrands(data?.data || []);
          setTotalPage(data?.totalPage || 1);
        })
        .finally(() => {
          setLoading(false);
        });
    }, 200);

    return () => {
      clearTimeout(timeout);

      try {
        abortController.signal.throwIfAborted();

        if (abortController.signal.aborted === false) abortController.abort();
      } catch (error) {}
    };
  }, [searchText]);

  // useEffect(() => {
  // 	window.scrollTo({
  // 		top: 0,
  // 		behavior: "smooth",
  // 	});
  // }, [page]);

  useEffect(() => {
    pageLoading.current = false;
  }, [brands]);

  const loadNextPage = (page: number) => {
    getAllBrands({
      currentPage: page,
      search: searchText,
      perPage: 20,
      sortBy: "serial_no",
      sortOrder: "ASC",
    }).then((data) => {
      setBrands((prev) => [...prev, ...(data?.data || [])]);
      setTotalPage(data?.totalPage || 1);
      setPage(page);
    });
  };

  const maxPages = Math.ceil(totalPage);

  const loadMoreHandler = () => {
    if (!pageLoading.current) {
      pageLoading.current = true;
      loadNextPage(page + 1);
    }
  };

  const Comp: any = InfiniteScroll;

  return (
    <div className="pb-6">
      <div className={`container`}>
        {/* search form */}
        <div className="flex pt-8">
          <div className="w-full md:w-1/2 lg:w-1/3 max-w-[500px]">
            <input
              type="text"
              className="w-full border border-gray-300 rounded-md p-2 focus:outline-none"
              placeholder="Search brand..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>
        </div>

        <Comp
          pageStart={0}
          loadMore={loadMoreHandler}
          threshold={500}
          initialLoad={false}
          hasMore={page < maxPages}
          loader={
            <div className="'w-full py-10 flex" key={"loader"}>
              <div className="mx-auto w-10 h-10 rounded-full border border-gray2 border-b-transparent animate-spin"></div>
            </div>
          }
        >
          <BrandList brands={brands} loading={loading} />
        </Comp>
      </div>
    </div>
  );
};

export default BrandListPage;
